import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.UserRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */
export default class UserRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.UserRestService#create
    * @methodOf rest.services.UserRestService
    * @function
    *
    * @description
    * Creates a user.
    *
    * @param {object} userPayload User payload
    *
    * @returns {Promise} The promise of the call.
    */
    create(userPayload, headers) {

        return super.create(userPayload, 'users/', headers);

    }


    /**
     * @ngdoc function
     * @name rest.services.UserRestService#getMeAsync
     * @methodOf rest.services.UserRestService
     * @function
     *
     * @description
     * Retrieves the logged user.
     *
     * @returns {Promise} The promise of the call.
     */
    getMeAsync() {

        return super.getAllAsync('me/');

    }

    /**
     * @ngdoc function
     * @name rest.services.UserRestService#getAllAsync
     * @methodOf rest.services.UserRestService
     * @function
     *
     * @description
     * Retrieves the logged user and his friends.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('users/');

    }

    /**
     * @ngdoc function
     * @name rest.services.UserRestService#update
     * @methodOf rest.services.UserRestService
     * @function
     *
     * @description
     * Updates a resource
     *
     * @param {string} userId UserId identifier
     * @param {object} payload Resource payload
     * @param {string} path API Resource path
     *
     * @returns {Promise} The promise of the call.
     */
    update(userId, userPayload, headers) {

        return super.update(userId, userPayload, 'users/', headers);

    }

}

_serviceDependencies.push(UserRestService);

angular.module('rest.services')
    .service('UserRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/userRestService.js